import React from 'react';
import { Link } from 'react-router-dom';

const ProductBreadcrumb = ({ product }) => {
  const crumbs = [
    { label: 'Home', to: '/' },
    { label: 'Products', to: '/products' },
    { label: 'Electrical', to: '/products' },
  ];

  return (
    <nav className="mb-3 flex flex-wrap items-center gap-1.5 rounded-xl bg-card/80 px-3 py-2.5 text-[12px] text-white/80 backdrop-blur-sm md:mb-0 md:rounded-none md:bg-transparent md:py-4 md:text-[13px] md:text-muted md:backdrop-blur-none" aria-label="Breadcrumb">
      {crumbs.map((crumb, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className="text-line">/</span>}
          <Link to={crumb.to} className="transition-colors duration-200 hover:text-brand">
            {crumb.label}
          </Link>
        </React.Fragment>
      ))}
      <span className="text-line">/</span>
      <span className="max-w-[300px] truncate text-white/90">{product?.title || 'Product'}</span>
    </nav>
  );
};

export default ProductBreadcrumb;
